
import { File, X } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";

interface FileListProps {
  files: File[];
  onRemove: (index: number) => void;
}

export function FileList({ files, onRemove }: FileListProps) {
  if (files.length === 0) return null;

  return (
    <ScrollArea className="h-[150px] sm:h-[200px] w-full rounded-md border border-white/10 p-2 sm:p-4">
      <div className="space-y-2">
        {Array.from(files).map((file, index) => (
          <div
            key={`${file.name}-${index}`}
            className="flex items-center justify-between p-2 sm:p-3 bg-white/5 backdrop-blur-sm rounded-lg border border-white/10"
          >
            <div className="flex items-center space-x-2 sm:space-x-3 min-w-0">
              <File className="h-4 w-4 sm:h-5 sm:w-5 text-white/80 flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-xs sm:text-sm font-medium text-white truncate max-w-[200px] sm:max-w-[300px]">
                  {file.name}
                </p>
                <p className="text-[10px] sm:text-xs text-white/60">
                  {(file.size / 1024 / 1024).toFixed(2)} MB
                </p>
              </div>
            </div>
            <button
              onClick={() => onRemove(index)}
              className="p-1 hover:bg-white/10 rounded-full transition-colors flex-shrink-0 ml-2"
              aria-label="Eliminar archivo"
            >
              <X className="h-3 w-3 sm:h-4 sm:w-4 text-white/80" />
            </button>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
